import React from 'react';
import { Link } from 'react-router-dom'
import CountUp from 'react-countup';
import Bg from '../../images/hero/business_consulting_hero_section_bg.jpg'
import shape1 from '../../images/hero/logo_google.svg'
import shape2 from '../../images/hero/business_consulting_hero_image_1.webp'
import shape3 from '../../images/hero/business_consulting_hero_image_2.webp'
import icon1 from '../../images/icons/icon_user_3.svg'
import icon2 from '../../images/icons/icon_wallet.svg'
import hero_bg_new from '../../images/hero_bg_new.png'
import cross from '../../images/cross.png'
import hero_box1 from '../../images/hero_box1.png'
import hero_box2 from '../../images/hero_box2.png'
import vectornew from '../../images/vectornew.png'



const Hero3 = (props) => {

    const ClickHandler = () => {
        window.scrollTo(10, 0);
    }
    return (
        <>
            <section className="business_consulting_hero_section section_decoration" style={{ backgroundImage: `url(${vectornew})` }}>
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="business_consulting_hero_content">
                                <span class="sub_heading">AI SEO</span>
                                <br/>
                                <br/>
                                
                                <h1> AI SEO Agency for Revenue, <br/> Not Just Rankings</h1>
                                <p>
                                    We help high-growth brands win AI answers, scale content, and turn <br/> organic traffic into qualified revenue.
                                </p>
                                <Link onClick={ClickHandler} className="creative_btn" to="/pricing">
                                    <span className="btn_label bg-primary">Book Strategy Call</span>
                                </Link>
                            </div>
                        </div>
                    
                    </div>
                </div>
            </section>

            <div className='hero_3d_section'>
            <spline-viewer url="https://prod.spline.design/BxULZuCreIAgMFNl/scene.splinecode"></spline-viewer>
            </div>
            <section className="section_decoration hero_bottom_section">
                
                <div className="container">
                    <div className='hero_box'>
                       <div className='row hero_box_row'>
                            <div className='col-md-6 col-6'>
                                <div className='hero_box_round'></div>
                            </div>
                            <div className='col-md-6 col-6 text-end'>
                                <img src={cross} alt="cross" className='cross_img'/>
                            </div>
                       </div>

                        <div className='row ai_seo_system'>
                            <div className='col-lg-12 col-md-12'>
                                <h2>AI SEO SYSTEM</h2>
                            </div>
                            <div className='col-lg-6 col-md-6'>
                                <div className='hero_box_content'>
                                    <img src={hero_box1} alt="icon" style={{width:'100%'}} />
                                </div>
                            </div>

                            <div className='col-lg-6 col-md-6'>
                                <div className='hero_box_content'>
                                    <img src={hero_box2} alt="icon" style={{width:'100%'}} />
                                </div>
                            </div>

                        </div>
                    </div>

                    <div className="row">
                        <div className='col-lg-12'>
                            <ul className='hero_bottom_stats'>
                                <li>
                                    <span className='number_css'>150+</span>
                                    <span className='hero_bottom_text'>Satisfied <br/> SEO Clients</span>
                                </li>
                                <li>
                                    <span className='number_css'>22+</span>
                                    <span className='hero_bottom_text'>Industries <br/> Served</span>
                                </li>
                                <li>
                                    <span className='number_css'>117+</span>
                                    <span className='hero_bottom_text'>AI Automation <br/> Templates</span>
                                </li>
                            </ul>
                        </div>
                    </div>
                 </div>
            </section>
        </>
    
    )
}

export default Hero3;